import React from "react";

export interface TimeTagProps {
  duration: string;
}
export const TimeTag: React.FC<TimeTagProps> = ({ duration }) => {
  return <span id="time">{duration}</span>;
};
